<template>
  <div id="app-login">
    <div class="login-box">
      <div class="logo-box">
        <router-link to="/">
          <img src="../../assets/images/big_logo.png" alt/>
        </router-link>
      </div>
      <el-form
        :model="loginForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <el-form-item label prop="mobile">
          <el-input v-model="loginForm.mobile" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label prop="code">
          <el-input placeholder="请输入验证码" v-model="loginForm.code">
            <el-button slot="append" @click="getSmsCode" :disabled="disabled">{{ btnText }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button type="danger" @click="login" :disabled="loginDisabled">登录</el-button>
      </div>
      <div class="bottom-box">
        <el-checkbox v-model="checked">下次自动登录</el-checkbox>
        <router-link to="/">返回首页</router-link>
      </div>
    </div>

    <slider-captcha
      v-model="visible"
      :options="options"
      :loading="loading"
      @check="check"
      @close="close"
      @refresh="getSliderOptions"
      @error="getSliderOptions"
    >
      <!--      <span slot="title">自定义标题-安全验证</span>-->
      <!--      <span slot="successText">自定义成功提示-登录中</span>-->
      <span slot="question">拖动滑块完成拼图</span>
      <span slot="tips">拖动下方滑块完成拼图</span>
    </slider-captcha>
  </div>
</template>
<script>

import {mapMutations} from "vuex";
import dragVerify from "vue-drag-verify";

export default {
  components: {
    dragVerify
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        this.phone = false;
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if (reg.test(value)) {
          this.phone = true;
          callback();
        } else {
          this.phone = false;
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      imgs: [
        "https://api.sfgy.org/verify/1d8acf9959fc4f35bcb5c67b9cddf6d6.jpeg",
        "https://api.sfgy.org/verify/2af75d69d4eb1d8a7a66d48de4be6c15.jpeg",
        "https://api.sfgy.org/verify/5bdf0d34437112b0d2d4a74188d7c9c3.jpeg",
        "https://api.sfgy.org/verify/9a88cdb0800c23d9c8571950eea7bc40.jpeg",
        "https://api.sfgy.org/verify/42d87a6909583c40aee943724113a6f7.jpeg",
        "https://api.sfgy.org/verify/76a8f30bfda313ce64eb2330ea5fd217.jpeg",
        "https://api.sfgy.org/verify/6076ce590ed091516fa84a32295b260a.jpeg",
        "https://api.sfgy.org/verify/68682c326bad9731f17208f9efcb7052.jpeg",
        "https://api.sfgy.org/verify/09958696c8d5e786d65cd3e0f4d65755.jpeg",
        "https://api.sfgy.org/verify/d0638b2f5926695eec465401e1ad8ed6.jpeg",
        "https://api.sfgy.org/verify/e2a56ac3eda5a884dddc6d6a25f91332.jpeg",
        "https://api.sfgy.org/verify/e36007a67dc30603a007d4c124f9c1b0.jpeg",
        "https://api.sfgy.org/verify/ecd3216363c0d3ffcc00af4f84bf3174.jpeg",
        "https://api.sfgy.org/verify/efb0ae5bce697f9c1334007dd357d2f9.jpeg",
        "https://api.sfgy.org/verify/f38177290057d5f66737f945f0906ba7.jpeg",
      ], //可以将所需的图片放在一个数组中，刷新后组件会自动随机抽取图片
      text: "向右拖动滑块填充拼图",
      cropperModal: false,
      phone: false, //手机号码是否验证通过
      register_date: "", //极验后台时间验证标识
      rules: {
        code: [{required: true, message: "请输入验证码", trigger: "blur"}],
        mobile: [{required: true, trigger: "blur", validator: checkPhone}]
      },
      captchaObj: null,
      gtCapValid: "",
      loginDisabled: true, //登录按钮默认置灰，等待行为校验通过后打开
      disabled: false,
      loginForm: {
        mobile: "",
        code: ""
      },
      visible: false,
      loading: false,
      options: {},
      sliderLoading: false,
      SmsKey: "",
      liStatus: 1,
      btnText: "获取验证码",
      checked: false
    };
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    getSmsCode() {
      let that = this;
      if (!this.phone) {
        that.$message.error("请输入正确的手机号码");
        return false;
      }
      if (!this.disabled) {
        this.visible = true;
        this.getSliderOptions()
      }

    },
    getSliderOptions() {
      //后台换取验证码
      this.sliderLoading = true
      this.$db.post(this.$url.send.captcha).then(resp => {
        this.options = {
          sliderImg: resp.data.img,
          sliderKey: resp.data.key,
          sliderY: resp.data.y,
        }
        this.sliderLoading = false

      })
    },
    // 验证
    check(key, value, done, error) {
      this.loading = true
      this.sliderLoading = true
      this.disabled = true;
      this.$db.post(this.$url.send.SmsCode, {
        key: key,
        value: value,
        mobile: this.loginForm.mobile
      }).then(resp => {
        this.loading = false
        this.sliderLoading = false
        if (resp.code == 200) {
          if (resp.data.pass) {
            done()
            let that = this;
            //关闭，并且发送短信
            setTimeout(() => {
              that.visible = false
              let timer = 60;
              let p = function (s) {
                return s < 10 ? "0" + s : s;
              };
              let CountDown = function () {
                if (timer >= 1) {
                  that.btnText = "重新发送(" + p(timer) + ")";
                  timer -= 1;
                  setTimeout(function () {
                    CountDown();
                  }, 1000);
                } else {
                  that.disabled = false;
                  that.btnText = "获取验证码";
                }
              };
              CountDown();
              that.SmsKey = resp.data.result.key;
              that.loginDisabled = false;
              that.$message.success("验证码已发送，请注意查收。");
              // that.$message.success("验证码已发送，请注意查收。" + resp.data.result.code);
            }, 500)
          } else {
            error();
            this.disabled = false;
          }
        } else {
          this.visible = false;
          this.disabled = false;
        }
      })
    },
    // 关闭触发
    close() {

    },
    onSuccess() {
      let _this = this;
      setTimeout(() => {
        this.cropperModal = false;
        this.$refs.verify.refresh();
        let data = {SlideVerify: 1};
        let token = _this.createToken({data});
        _this.disabled = true;
        _this.$db.getSmsCode({
          mobile: _this.loginForm.mobile,
          token: token,
          success: function (e) {
            let timer = 60;
            let p = function (s) {
              return s < 10 ? "0" + s : s;
            };
            let CountDown = function () {
              if (timer >= 1) {
                _this.btnText = "重新发送(" + p(timer) + ")";
                timer -= 1;
                setTimeout(function () {
                  CountDown();
                }, 1000);
              } else {
                _this.disabled = false;
                _this.btnText = "获取验证码";
              }
            };
            CountDown();
            _this.SmsKey = e.data.key;
            _this.loginDisabled = false;
            _this.$message.success("验证码已发送，请注意查收。" + e.data.code);
            // _this.$message.success("验证码已发送，请注意查收。" );
          },
          error: function (err) {
            _this.$message.error(err.errMsg);
          }
        });
      }, 500);
    },
    onFail() {
      console.log("onFail");
    },
    onRefresh() {
      console.log("onRefresh");
    },
    getStyle(id) {
      this.liStatus = id;
    },
    login() {
      let redirect = this.$route.query.redirect;
      //先校验验证码是否正确
      let that = this;
      that.loginDisabled = true;
      that.$db.checkSmscode({
        mobile: that.loginForm.mobile,
        key: that.SmsKey,
        code: that.loginForm.code,
        success: function (e) {
          that.setUserInfo(e.data);
          that.$message({
            message: "登录成功，页面正在跳转。",
            type: "success",
            onClose: function () {
              if (redirect) {
                that.$router.push(redirect);
              } else {
                that.$router.push({name: "centerHomeIndex"});
              }
            }
          });
        },
        error: function (err) {
          that.$message.error(err.errMsg);
          that.loginDisabled = false;
        }
      });
    },

  },
  mounted() {
    //this.initGtCaptcha();
    //this.$router.push({ name: "centerHomeIndex" });
    // const jwt = require("jsonwebtoken");
    // let token = jwt.sign({ user: "1234" }, "Fizz", { expiresIn: 60 * 60 });
    // console.log(token);
    // jwt.verify(token, "Fizz", function(err, data) {
    //   if (err) console.log(err);
    //   console.log("解析的数据", data);
    // });
  }
};
</script>

<style lang="scss" scoped>
#app-login {
  width: 100%;
  height: 100%;
  background: url(../../assets/images/login_bg.png) no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.login-box {
  width: 430px;
  height: 435px;
  background-color: #ffffff;
  box-shadow: 1px 2px 21px 0px rgba(11, 2, 5, 0.27);
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 8.8%;
  padding: 0 35px;
  overflow: hidden;

  .logo-box {
    width: 117px;
    height: 101px;
    margin: 30px auto;

    > a {
      > img {
        width: 100%;
        height: 100%;
      }
    }
  }

  > ul {
    display: flex;
    border-bottom: 1px solid #ddd;

    > li {
      list-style: none;
      padding: 25px 12px;
      padding-top: 16px;
      margin-right: 40px;
      font-size: 16px;
      color: #666;
      cursor: pointer;

      &.active {
        color: #e83a16;
        border-bottom: 3px solid #e83a16;
      }
    }
  }

  .phone-box {
    margin-top: 40px;
    width: 100%;

    > input {
      margin: 0;
      padding: 0;
      outline: none;
      border: none;
      width: calc(100% - 34px);
      padding: 15px 16px;
      border: 1px solid #ddd;
      border-radius: 4px;
      font-size: 16px;
      color: #666;
    }
  }

  .code-box {
    margin-top: 30px;
    width: 100%;
    position: relative;
    border: 1px solid #ddd;
    border-radius: 4px;

    > input {
      margin: 0;
      padding: 0;
      outline: none;
      border: none;
      width: calc(100% - 132px);
      padding: 15px 16px;
      border-radius: 4px;
      font-size: 16px;
      color: #666;
    }

    > button {
      margin: 0;
      padding: 0;
      outline: none;
      border: none;
      font-size: 16px;
      color: #469ed7;
      position: absolute;
      top: 50%;
      right: 17px;
      transform: translateY(-50%);
      background-color: #fff;
    }
  }

  .btn-box {
    width: 100%;
    margin-top: 30px;

    > button {
      margin: 0;
      padding: 0;
      outline: none;
      border: none;
      font-size: 16px;
      color: #fff;
      width: 100%;
      padding: 15px 0;
      text-align: center;
      border-radius: 4px;
    }
  }

  .bottom-box {
    margin-top: 26px;
    display: flex;
    justify-content: space-between;

    > a {
      font-size: 14px;
      color: #999999;
    }
  }
}

.logo-foot {
  margin-top: 20px;

  > h5 {
    font-size: 14px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
    margin-bottom: 6px;
  }

  > p {
    font-size: 14px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
  }
}

.bottom-box /deep/ .el-checkbox {
  color: #999;
}

.bottom-box /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #e83a16;
}

.bottom-box /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #e83a16;
  background-color: #e83a16;
}
</style>



// WEBPACK FOOTER //
// src/view/Public/login.vue